import { z } from 'zod';
import { request } from './client';

export const userPreferencesSchema = z.object({
  theme: z.enum(['light']),
  locale: z.string(),
  timezone: z.string(),
  emailNotify: z.boolean(),
});
export type UserPreferences = z.infer<typeof userPreferencesSchema>;

export const userSchema = z.object({
  id: z.string(),
  email: z.string(),
  nickname: z.string().nullable().optional(),
  avatarKey: z.string().nullable().optional(),
  emailVerifiedAt: z.string().nullable().optional(),
  lastLoginAt: z.string().nullable().optional(),
  createdAt: z.string(),
  preferences: userPreferencesSchema.optional(),
});
export type User = z.infer<typeof userSchema>;

export const usersApi = {
  /** 当前用户信息 */
  me: () => request<User>('/users/me'),

  /** 更新资料 */
  updateProfile: (body: { nickname?: string; avatarKey?: string | null }) =>
    request<{ id: string; updated: boolean }>('/users/me', {
      method: 'PATCH',
      body: JSON.stringify(body),
    }),

  /** 更新偏好 */
  updatePreferences: (body: Partial<UserPreferences>) =>
    request<{ id: string; updated: boolean; preferences: UserPreferences }>(
      '/users/me/preferences',
      { method: 'PATCH', body: JSON.stringify(body) },
    ),

  /** 修改密码 */
  changePassword: (body: { oldPassword: string; newPassword: string }) =>
    request<{ ok: boolean }>('/users/me/password', {
      method: 'POST',
      body: JSON.stringify(body),
    }),
};
